import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import './fontawesome';
import './validation';

import VuePhotoSwipe from './plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    throttleWait: 0,
    listenEvents: ['load', 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
    observer: true,
    observerOptions: {
        rootMargin: '0px',
        threshold: 0.1,
    },
});

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: '#95c021',
    failedColor: '#fac428',
    // thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 100,
    },
    position: 'absolute',
});

// import Sticky from 'vue-sticky-directive'
// Vue.use(Sticky)

import TreeMenu from '@/components/TreeMenu';
Vue.component('tree-menu', TreeMenu);

import { apolloProvider } from './store/apollo';

import '@/init';
import '@/router/middleware';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    apolloProvider,
    render: (h) => h(App),
}).$mount('#app');
